import { useState, useEffect } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";

export default function AddMultiBundle() {
  const [products, setProducts] = useState([]);
  const [bundleName, setBundleName] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([
    { productId: "", productName: "", discount: 0 },
  ]);
  const [bundles, setBundles] = useState([]);
  const [editingBundleId, setEditingBundleId] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      const querySnapshot = await getDocs(collection(db, "product"));
      const list = [];
      querySnapshot.forEach((doc) => {
        list.push({ id: doc.id, ...doc.data() });
      });
      setProducts(list);
    };

    const fetchBundles = async () => {
      const querySnapshot = await getDocs(collection(db, "bundles"));
      const list = [];
      querySnapshot.forEach((doc) => {
        list.push({ id: doc.id, ...doc.data() });
      });
      setBundles(list);
    };

    fetchProducts();
    fetchBundles();
  }, []);

  const handleProductSearch = (index, value) => {
    const updated = [...selectedProducts];
    updated[index].productName = value;

    const match = products.find((p) =>
      p.bookName.toLowerCase().includes(value.toLowerCase())
    );
    updated[index].productId = match ? match.id : "";

    setSelectedProducts(updated);
  };

  const handleProductDiscountChange = (index, value) => {
    const updated = [...selectedProducts];
    updated[index].discount = value;
    setSelectedProducts(updated);
  };

  const addProductField = () => {
    setSelectedProducts([
      ...selectedProducts,
      { productId: "", productName: "", discount: 0 },
    ]);
  };

  const removeProductField = (index) => {
    const updated = [...selectedProducts];
    updated.splice(index, 1);
    setSelectedProducts(updated);
  };

  const handleSaveBundle = async () => {
    if (!bundleName || selectedProducts.length < 2) {
      alert("Додайте мінімум 2 товари!");
      return;
    }

    const hasMissing = selectedProducts.some((p) => p.productId === "");
    if (hasMissing) {
      alert("Перевірте товари — деякі не знайдено.");
      return;
    }

    if (editingBundleId) {
      // Update існуючої зв’язки
      await updateDoc(doc(db, "bundles", editingBundleId), {
        name: bundleName,
        products: selectedProducts.map(({ productId, discount }) => ({
          productId,
          discount: parseFloat(discount),
        })),
      });
      alert("Зв’язка оновлена!");
    } else {
      // Створення нової зв’язки
      await addDoc(collection(db, "bundles"), {
        name: bundleName,
        products: selectedProducts.map(({ productId, discount }) => ({
          productId,
          discount: parseFloat(discount),
        })),
      });
      alert("Зв’язка створена!");
    }

    setBundleName("");
    setSelectedProducts([{ productId: "", productName: "", discount: 0 }]);
    setEditingBundleId(null);

    const querySnapshot = await getDocs(collection(db, "bundles"));
    const list = [];
    querySnapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    setBundles(list);
  };

  const handleDeleteBundle = async (bundleId) => {
    await deleteDoc(doc(db, "bundles", bundleId));
    setBundles(bundles.filter((b) => b.id !== bundleId));

    // Якщо видаляєш ту, що зараз редагується
    if (editingBundleId === bundleId) {
      setBundleName("");
      setSelectedProducts([{ productId: "", productName: "", discount: 0 }]);
      setEditingBundleId(null);
    }
  };

  const handleEditBundle = (bundle) => {
    setEditingBundleId(bundle.id);
    setBundleName(bundle.name);
    setSelectedProducts(
      bundle.products.map((p) => {
        const prod = products.find((prod) => prod.id === p.productId);
        return {
          productId: p.productId,
          productName: prod ? prod.bookName : "",
          discount: p.discount,
        };
      })
    );
  };

  return (
    <div
      style={{ maxWidth: "700px", padding: "20px", border: "1px solid #ddd" }}
    >
      <h2>
        {editingBundleId ? "✏️ Редагувати зв’язку" : "📦 Створити зв’язку"}
      </h2>

      <div style={{ marginBottom: "15px" }}>
        <label>Назва зв’язки:</label>
        <input
          type="text"
          value={bundleName}
          onChange={(e) => setBundleName(e.target.value)}
          style={{ display: "block", width: "100%", padding: "8px" }}
        />
      </div>

      <h4>Товари у зв’язці:</h4>
      {selectedProducts.map((item, index) => (
        <div key={index} style={{ marginBottom: "15px" }}>
          <input
            type="text"
            placeholder="Введіть назву книги"
            value={item.productName}
            onChange={(e) => handleProductSearch(index, e.target.value)}
            style={{ width: "60%", marginRight: "10px", padding: "6px" }}
          />
          <input
            type="number"
            placeholder="Знижка %"
            value={item.discount}
            onChange={(e) => handleProductDiscountChange(index, e.target.value)}
            style={{ width: "80px", padding: "6px" }}
          />
          <button onClick={() => removeProductField(index)}>❌</button>
          <div style={{ fontSize: "12px", color: "#888" }}>
            {item.productId ? `ID: ${item.productId}` : "❌ Не знайдено"}
          </div>
          {item.productName && (
            <div
              style={{
                background: "#fff",
                border: "1px solid #ccc",
                maxHeight: "120px",
                overflowY: "auto",
              }}
            >
              {products
                .filter((p) =>
                  p.bookName
                    .toLowerCase()
                    .includes(item.productName.toLowerCase())
                )
                .slice(0, 5)
                .map((p) => (
                  <div
                    key={p.id}
                    style={{
                      padding: "5px 10px",
                      cursor: "pointer",
                      borderBottom: "1px solid #eee",
                    }}
                    onClick={() => {
                      const updated = [...selectedProducts];
                      updated[index].productName = p.bookName;
                      updated[index].productId = p.id;
                      setSelectedProducts(updated);
                    }}
                  >
                    {p.bookName}
                  </div>
                ))}
            </div>
          )}
        </div>
      ))}

      <button onClick={addProductField}>➕ Додати товар</button>

      <br />
      <br />
      <button onClick={handleSaveBundle} style={{ padding: "8px 15px" }}>
        ✅ {editingBundleId ? "Оновити зв’язку" : "Зберегти зв’язку"}
      </button>

      <h3>Існуючі зв’язки:</h3>
      {bundles.map((b) => (
        <div
          key={b.id}
          style={{
            background: "#fafafa",
            margin: "10px 0",
            padding: "10px",
            border:
              editingBundleId === b.id ? "2px solid #007a4e" : "1px solid #ddd",
          }}
        >
          <strong>{b.name}</strong>
          <ul>
            {b.products.map((p, i) => (
              <li key={i}>
                {products.find((prod) => prod.id === p.productId)?.bookName} —{" "}
                {p.discount}%
              </li>
            ))}
          </ul>
          <button onClick={() => handleEditBundle(b)}>✏️ Редагувати</button>{" "}
          <button onClick={() => handleDeleteBundle(b.id)}>❌ Видалити</button>
        </div>
      ))}
    </div>
  );
}
